import { useRef } from 'react';
var defaultEverTargetValue = function (value) { return !!value; };
/**
 * that value ever to be `you want value`
 * Return true when the value ever to be `you want value` once.
 *
 * @example
 * ```ts
 * // once that isOpen is true, that result will always be `true`
 * const isEverOpen = useEver(isOpen);
 *
 * const isEverToBe2 = useEver(count, (val) => val === 2);
 * ```
 */
export var useEver = function (
/** to be checked value */
value, 
/**
 * value ever to be callback, default when value to be exited.
 *
 * @default (value) => !!value
 */
targetValue) {
    if (targetValue === void 0) { targetValue = defaultEverTargetValue; }
    var result = useRef(false);
    if (!result.current) {
        result.current = targetValue(value);
    }
    return result.current;
};
